'use client'
import React, { useState, useEffect } from 'react'
import { VARIANT } from '@/src/utils/buildUtils'
import { CLEARTRIP } from '@/src/constants/buildVariants'
import FlyinHeaderContainer from '../flyinHeader'
import CTHeaderContainer from '../ctHeader'
import { domainCountry } from '@/src/constants/domain'

interface HeaderContainerProps {
    hideSignIn?: boolean
}

const HeaderContainer: React.FC<HeaderContainerProps> = ({ hideSignIn = false }) => {
    const [isClient, setIsClient] = useState(false)

    useEffect(() => {
        setIsClient(true)
    }, [])

    // Show FlyinHeader for FEG and FSA domains, CTHeader for all others
    const showFlyinHeader = domainCountry === 'FEG' || domainCountry === 'FSA' || domainCountry === 'FAE'

    // During SSR and initial hydration, always render FlyinHeader to prevent mismatch
    if (!isClient) {
        return <FlyinHeaderContainer hideSignIn={hideSignIn} />
    }

    return showFlyinHeader ? (
        <FlyinHeaderContainer hideSignIn={hideSignIn} />
    ) : (
        <CTHeaderContainer hideSignIn={hideSignIn} />
    )
}

export { HeaderContainer }
export default HeaderContainer
